  <template>
  <div>
    <bid-in-request :lot="lot" :bid="bid"></bid-in-request>

    <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_APPEND_DIVIDING_COST_FILE">
      <div class="a-label a-label--w-280">{{$t('form.lot.dividing-total-price-to-parts')}}:</div>
      <div >
        <file-link :name="file.name"
                   :size="file.size"
                   :link="externalLink(file.uid)"
                   :removable="bid.permissions.CAN_ADD_DIVIDING_COST_FILE"
                   :key="file.uid"
                   :signed="file.hasSign"

                   @remove="onRemoveCostDividingFile(file.id)"
                   v-for="file in bid.dividingFiles">
        </file-link>

        <file-picker @prepared="onCostDividingFileSelected"
                     :signing="lot.permissions.SHOULD_BE_SIGNED"
                     v-if="bid.permissions.CAN_ADD_DIVIDING_COST_FILE">
        </file-picker>
        <p class="a-input a-input--disabled" v-else-if="bid.dividingFiles.length === 0">{{$t('labels.no-files')}}</p>
      </div>
    </div>

    <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_APPROVE_BID || lot.permissions.CAN_SEE_PUBLIC_LOT_ACCEPT_BID">
      <div class="a-container-form" >
        <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.bid-status')}}:</div>
        <dropdown-new ref="bidState"
                      class="a-input-group select-w-180"
                      :options="bidStates"
                      :placeholder="$t('bid-state.none')"
                      v-model="bid.state">
        </dropdown-new>
        <button type="button"
                class="gui-btn gui-btn--red"
                :disabled="!isBidStateChanged && !isAcceptedDateChanged"
                @click="onApproveBidClick({ verdict: bid.state, reason: bid.reason, regulationsReason: bid.regulationsReason, acceptTime: bid.acceptTime})">{{$t('buttons.save')}}</button>
      </div>
      <div class="a-container-form" v-if="bid.confirmedState">
        <div class="a-label a-label--w-280">{{$t('form.lot.confirmed-request-status')}}:</div>
        <label class="a-input a-input--disabled u-red-color">{{$t(bid.confirmedState.label)}}</label>
      </div>

      <div class="a-container-form" v-if="bid.permissions.CAN_ATTACH_RESULT_FILE">
        <div class="a-label a-label--w-280"></div>
        <div class="gui-btn-block" v-if="!bid.confirmedState && bid.state == enums.BidState.DECLINED">
          <button class="gui-btn gui-btn--red"
                  @click.prevent="onDownloadDeclineFile">
            Выгрузить отклонение
          </button>

          <file-picker @prepared="onAttachBidDeclineFile"
                       btn-class="gui-btn gui-btn--red"
                       label="Прикрепить отклонение"
                       :signing="lot.permissions.SHOULD_BE_SIGNED">
          </file-picker>
        </div>
        <div class="gui-btn-block" v-else-if="!bid.confirmedState && bid.state == enums.BidState.ACCEPTED">
          <button class="gui-btn gui-btn--red"
                  @click.prevent="onDownloadAcceptFile">
            Выгрузить акцепт
          </button>

          <file-picker @prepared="onAttachBidAcceptFile"
                       class="gui-btn gui-btn--red"
                       label="Прикрепить акцепт"
                       :signing="lot.permissions.SHOULD_BE_SIGNED">
          </file-picker>
        </div>
      </div>

      <div class="a-container-form">
        <div class="a-label a-label--w-280"></div>
        <div>
          <file-link :name="file.name"
                     :size="file.size"
                     :link="externalLink(file.uid)"
                     :key="file.uid"
                     :signed="file.hasSign"
                     v-for="file in bid.filesState">
          </file-link>
        </div>
      </div>

      <template v-if="bid.state == enums.BidState.DECLINED || bid.state == enums.BidState.CONDITIONALLY_APPROVED">
        <div class="a-container-form">
          <div class="a-label a-label--auto">В соответствии с пунктом Регламента ЭТП:</div>
          <regulations-paragraphs-picker class="a-input-group select-w-180"
                                         @input="value => bid.regulationsReason = value.join('\n\n')"/>
        </div>

        <div class="a-container-form">
            <textarea class="a-textarea accreditation__textarea"
                      rows="4"
                      disabled
                      :value="bid.regulationsReason"
                      placeholder="Тексты пунктов">
            </textarea>
        </div>
      </template>

      <template v-if="bid.state == enums.BidState.DECLINED">
        <div class="a-container-form">
          <div class="a-label a-label--auto">В дополнение к регламенту:</div>
          <textarea class="a-textarea accreditation__textarea"
                    rows="2"
                    :disabled="!isBidStateChanged"
                    :placeholder="$t('labels.reason')"
                    v-model="bid.reason">
          </textarea>
        </div>

        <div class="a-container-form" v-if="bid.confirmedReason" >
          <a class="a-textarea a-textarea--disabled accreditation__textarea" v-model="bid.confirmedReason"></a>
        </div>
      </template>

      <template v-if="bid.state == enums.BidState.ACCEPTED">
        <div class="a-container-form">
          <div class="a-label a-label--w-280">Дата акцепта</div>
          <date-picker v-model="bid.acceptTime"></date-picker>
        </div>
      </template>
    </template>

<!--    <div class="a-container-form" v-if="bid.permissions.CAN_DOWNLOAD_ACCEPT">-->
<!--      <button class="gui-btn gui-btn&#45;&#45;red" type="button" @click="onDownloadAcceptFile">{{$t('buttons.accept-bid')}}</button>-->
<!--    </div>-->

    <div class="a-container-form" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_REMOVE_BID && lot.request.permissions.CAN_REMOVE_BID">
      <button class="gui-btn gui-btn--red" type="button" @click="onRemoveBidClick">{{$t('buttons.delete-bid')}}</button>
    </div>
    <div class="a-container-form" v-if="lot.request.permissions.CAN_ADD_BID">
      <button class="gui-btn gui-btn--red" type="button" :disabled="!lot.request.isFilled" @click="onAddBidClick">{{$t('buttons.add-bid')}}</button>
    </div>
    <div class="a-container-form" v-if="lot.request.permissions.CAN_SEE_PUBLIC_LOT_SIGN_REQUEST">
      <router-link class="gui-btn gui-btn--red gui-btn--w-300"
                   tag="button"
                   :disabled="!lot.request.isFilled"
                   to="request#sending-request">
        Перейти для подписания заявки
      </router-link>
    </div>

  </div>
</template>

<script>
  import BidInRequest from '../../request/BidInRequest'
  import CommonMixins from '../../mixins/common'
  import RegulationsParagraphsPicker from '@/components/common/inputs/RegulationsParagraphsPicker'

  export default {
    components: {
      BidInRequest,
      RegulationsParagraphsPicker
    },

    props: {
      lot: Object,
      bid: Object
    },

    mixins: [
      CommonMixins
    ],

    computed: {
      isBidStateChanged() {
        return this.bid.state.valueOf() != this.bid.stateOriginal.valueOf();
      },

      isAcceptedDateChanged() {
        const acceptTime = this.bid.acceptTime ? this.bid.acceptTime.valueOf() : undefined;
        const acceptTimeOriginal = this.bid.acceptTimeOriginal ? this.bid.acceptTimeOriginal.valueOf() : undefined;
        return acceptTime !== acceptTimeOriginal;
      }
    },

    methods: {
      async onCostDividingFileSelected(data) {
        if (data instanceof File) {
          data = {
            file: data,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('appendDividingCostFileToBid', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.num,
              file: data.file,
              sign: data.sign
            })
          }
          catch (e) {
            console.error('failed appending dividing cost file', e);
            this.globalErrorHandler(e,  {
              'BAD_SIGNATURE': 'errors.public-lot.cost-dividing.bad-signature',
            }, 'errors.public-lot.cost-dividing.unknown');
          }
        })
      },

      async onRemoveCostDividingFile(fileId) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeDividingCostFileFromBid', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.num,
              fileId
            })
          }
          catch (e) {
            console.error('failed removing dividing cost file', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onDownloadAcceptFile() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('exportBidAcceptFile', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id
            });
          }
          catch(e) {
            console.error('failed downloading accept', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onDownloadDeclineFile() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('exportBidDeclineFile', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id
            });
          }
          catch(e) {
            console.error('failed downloading accept', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onAttachBidDeclineFile(data) {
        if (data instanceof File) {
          data = {
            file: data,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('attachBidDeclineFile', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.num,
              file: data.file,
              sign: data.sign
            })
          }
          catch (e) {
            console.error('failed appending bid decline file', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onAttachBidAcceptFile(data) {
        if (data instanceof File) {
          data = {
            file: data,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('attachBidAcceptFile', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.num,
              file: data.file,
              sign: data.sign
            })
          }
          catch (e) {
            console.error('failed appending bid accept file', e);
            this.globalErrorHandler(e);
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
